import {useContext} from 'react';
import {Link} from 'react-router-dom';
import { BsGeoAlt } from 'react-icons/bs';
import Button from 'react-bootstrap/Button';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import {AppConfigState} from '../providers/AppConfigProvider';


const Menu = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${({ theme}) => theme.background.overlay};
  position: fixed;
  top: 0;
  right: 0;
  transition: transform .3s;
  cubic-bezier(0, .52, 0, 1);
  overflow: scroll;
  z-index: 1000;
  display: flex;
  flex-direction: column;
  padding: 1rem;

  ${({ show }) => show ? `
    transform: translate3d(0vw, 0, 0);
    overflow-y: scroll;
  ` :
  'transform: translate3d(-100vw, 0, 0);'}
`;

const MenuLinkCmp = styled(Link)`
  color: ${({ theme }) => theme.text.link};
  margin-left: 15px;
  text-decoration: none;
  font-size: 1.5rem;

  &:hover {
    text-decoration: underline;
    color: ${({ theme }) => theme.text.link};
  }
`;

const MenuContentCmp = ({children}) => {
  const appConfig = useContext(AppConfigState);
  const click = () => {
    appConfig.dispatch({type: 'toggleMenu'});
  }

  return (
    <Menu onClick={click} show={appConfig.state.menuIsVisible}>
      {children}
    </Menu>
  );
}

MenuContentCmp.propTypes = {
  children: PropTypes.node,
}

const MenuButtonCmp = () => {
  const appConfig = useContext(AppConfigState);

  const click = () => {
    appConfig.dispatch({type: 'closeChat'});
    appConfig.dispatch({type: 'toggleMenu'});
  }

  return (
    <Button id="colour" variant="light" onClick={click}>
      <BsGeoAlt />
    </Button>
  );
}

export {
  MenuButtonCmp,
  MenuContentCmp,
  MenuLinkCmp,
}
